module.exports = __webpack_public_path__ + "static/media/6042.f934e8b2.jpg";